<template>
    <div>

        <!-- Table -->

        <trax-ui-card-icon-header icon="call_missed_outgoing" 
            :title="lang.polaris.procedure.atp_daf" :actions="card_actions" :bus="bus">

            <enac-atpl-dashboard-atp-daf-table :bus="bus">
            </enac-atpl-dashboard-atp-daf-table>

        </trax-ui-card-icon-header>

        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <enac-atpl-dashboard-atp-daf-search :id="id" :bus="bus"></enac-atpl-dashboard-atp-daf-search>
        </trax-ui-modal-default>

    </div>
</template>

<script>
    export default {

        props: {
            id: { default: 'home-atp-daf' },
        },

        data: function() {
            return {
                user: user,
                lang: lang,
                bus: new Vue()
            }
        },

        computed: {

            card_actions() {
                return [
                    { icon: 'search', event: this.id + '-search-open' }
                ];
            }
        }
    }
</script>
